var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _rect228, _rect229, _rect230, _rect231, _rect232, _rect233, _rect234, _rect235, _rect236, _rect237, _rect238, _rect239, _rect240, _rect241, _rect242, _rect243, _rect244, _rect245, _rect246, _rect247, _rect248, _rect249, _rect250;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1102,
    height: 65,
    viewBox: "0 0 1102 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 92.8184,
    width: 1.42,
    height: 64.2907,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 88.3984,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 83.9785,
    y: 16.9186,
    width: 1.42,
    height: 47.3721,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 79.5586,
    width: 1.42,
    height: 64.2907,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 75.1387,
    y: 13.5349,
    width: 1.42,
    height: 50.7558,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 70.7188,
    y: 30.4535,
    width: 1.42,
    height: 33.8372,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 66.2988,
    y: 6.76746,
    width: 1.42,
    height: 57.5233,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 61.8789,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 57.459,
    y: 47.3721,
    width: 1.42,
    height: 16.9186,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 53.0391,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 48.6191,
    y: 16.9186,
    width: 1.42,
    height: 47.3721,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 44.1992,
    y: 33.8372,
    width: 1.42,
    height: 30.4535,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 39.7793,
    y: 10.1511,
    width: 1.42,
    height: 54.1395,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3594,
    y: 30.4535,
    width: 1.42,
    height: 33.8372,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 30.9395,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5195,
    width: 1.42,
    height: 64.2907,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0996,
    y: 33.8372,
    width: 1.42,
    height: 30.4535,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 17.6797,
    y: 20.3024,
    width: 1.42,
    height: 43.9884,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 13.2598,
    y: 47.3721,
    width: 1.42,
    height: 16.9186,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 8.83984,
    y: 6.76746,
    width: 1.42,
    height: 57.5233,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 4.41992,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    y: 16.9186,
    width: 1.42,
    height: 47.3721,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 190.818,
    width: 1.42,
    height: 64.2907,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 186.398,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 181.979,
    y: 16.9186,
    width: 1.42,
    height: 47.3721,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 177.559,
    width: 1.42,
    height: 64.2907,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 173.139,
    y: 13.5349,
    width: 1.42,
    height: 50.7558,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 168.719,
    y: 30.4535,
    width: 1.42,
    height: 33.8372,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 164.299,
    y: 6.76746,
    width: 1.42,
    height: 57.5233,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 159.879,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 155.459,
    y: 47.3721,
    width: 1.42,
    height: 16.9186,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 151.039,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 146.619,
    y: 16.9186,
    width: 1.42,
    height: 47.3721,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 142.199,
    y: 33.8372,
    width: 1.42,
    height: 30.4535,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 137.779,
    y: 10.1511,
    width: 1.42,
    height: 54.1395,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 133.359,
    y: 30.4535,
    width: 1.42,
    height: 33.8372,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 128.939,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 124.52,
    width: 1.42,
    height: 64.2907,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 120.1,
    y: 33.8372,
    width: 1.42,
    height: 30.4535,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 115.68,
    y: 20.3024,
    width: 1.42,
    height: 43.9884,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 111.26,
    y: 47.3721,
    width: 1.42,
    height: 16.9186,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 106.84,
    y: 6.76746,
    width: 1.42,
    height: 57.5233,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 102.42,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 16.9186,
    width: 1.42,
    height: 47.3721,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 287.818,
    width: 1.42,
    height: 64.2907,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 283.398,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 278.979,
    y: 16.9186,
    width: 1.42,
    height: 47.3721,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 274.559,
    width: 1.42,
    height: 64.2907,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 270.139,
    y: 13.5349,
    width: 1.42,
    height: 50.7558,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 265.719,
    y: 30.4535,
    width: 1.42,
    height: 33.8372,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 261.299,
    y: 6.76746,
    width: 1.42,
    height: 57.5233,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 256.879,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 252.459,
    y: 47.3721,
    width: 1.42,
    height: 16.9186,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 248.039,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 243.619,
    y: 16.9186,
    width: 1.42,
    height: 47.3721,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 239.199,
    y: 33.8372,
    width: 1.42,
    height: 30.4535,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 234.779,
    y: 10.1511,
    width: 1.42,
    height: 54.1395,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 230.359,
    y: 30.4535,
    width: 1.42,
    height: 33.8372,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 225.939,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 221.52,
    width: 1.42,
    height: 64.2907,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 217.1,
    y: 33.8372,
    width: 1.42,
    height: 30.4535,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 212.68,
    y: 20.3024,
    width: 1.42,
    height: 43.9884,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 208.26,
    y: 47.3721,
    width: 1.42,
    height: 16.9186,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 203.84,
    y: 6.76746,
    width: 1.42,
    height: 57.5233,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 199.42,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 16.9186,
    width: 1.42,
    height: 47.3721,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 384.818,
    width: 1.42,
    height: 64.2907,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 380.398,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 375.979,
    y: 16.9186,
    width: 1.42,
    height: 47.3721,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 371.559,
    width: 1.42,
    height: 64.2907,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 367.139,
    y: 13.5349,
    width: 1.42,
    height: 50.7558,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 362.719,
    y: 30.4535,
    width: 1.42,
    height: 33.8372,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 358.299,
    y: 6.76746,
    width: 1.42,
    height: 57.5233,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 353.879,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 349.459,
    y: 47.3721,
    width: 1.42,
    height: 16.9186,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 345.039,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 340.619,
    y: 16.9186,
    width: 1.42,
    height: 47.3721,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 336.199,
    y: 33.8372,
    width: 1.42,
    height: 30.4535,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 331.779,
    y: 10.1511,
    width: 1.42,
    height: 54.1395,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 327.359,
    y: 30.4535,
    width: 1.42,
    height: 33.8372,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 322.939,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 318.52,
    width: 1.42,
    height: 64.2907,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 314.1,
    y: 33.8372,
    width: 1.42,
    height: 30.4535,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 309.68,
    y: 20.3024,
    width: 1.42,
    height: 43.9884,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 305.26,
    y: 47.3721,
    width: 1.42,
    height: 16.9186,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 300.84,
    y: 6.76746,
    width: 1.42,
    height: 57.5233,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 296.42,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 16.9186,
    width: 1.42,
    height: 47.3721,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 481.818,
    width: 1.42,
    height: 64.2907,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 477.398,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 472.979,
    y: 16.9186,
    width: 1.42,
    height: 47.3721,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 468.559,
    width: 1.42,
    height: 64.2907,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 464.139,
    y: 13.5349,
    width: 1.42,
    height: 50.7558,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 459.719,
    y: 30.4535,
    width: 1.42,
    height: 33.8372,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 455.299,
    y: 6.76746,
    width: 1.42,
    height: 57.5233,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 450.879,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 446.459,
    y: 47.3721,
    width: 1.42,
    height: 16.9186,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 442.039,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 437.619,
    y: 16.9186,
    width: 1.42,
    height: 47.3721,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 433.199,
    y: 33.8372,
    width: 1.42,
    height: 30.4535,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 428.779,
    y: 10.1511,
    width: 1.42,
    height: 54.1395,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 424.359,
    y: 30.4535,
    width: 1.42,
    height: 33.8372,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 419.939,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 415.52,
    width: 1.42,
    height: 64.2907,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 411.1,
    y: 33.8372,
    width: 1.42,
    height: 30.4535,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 406.68,
    y: 20.3024,
    width: 1.42,
    height: 43.9884,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 402.26,
    y: 47.3721,
    width: 1.42,
    height: 16.9186,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 397.84,
    y: 6.76746,
    width: 1.42,
    height: 57.5233,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 393.42,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 16.9186,
    width: 1.42,
    height: 47.3721,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 578.818,
    width: 1.42,
    height: 64.2907,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 574.398,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 569.979,
    y: 16.9186,
    width: 1.42,
    height: 47.3721,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 565.559,
    width: 1.42,
    height: 64.2907,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 561.139,
    y: 13.5349,
    width: 1.42,
    height: 50.7558,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 556.719,
    y: 30.4535,
    width: 1.42,
    height: 33.8372,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 552.299,
    y: 6.76746,
    width: 1.42,
    height: 57.5233,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 547.879,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 543.459,
    y: 47.3721,
    width: 1.42,
    height: 16.9186,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 539.039,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 534.619,
    y: 16.9186,
    width: 1.42,
    height: 47.3721,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 530.199,
    y: 33.8372,
    width: 1.42,
    height: 30.4535,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 525.779,
    y: 10.1511,
    width: 1.42,
    height: 54.1395,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 521.359,
    y: 30.4535,
    width: 1.42,
    height: 33.8372,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 516.939,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 512.52,
    width: 1.42,
    height: 64.2907,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 508.1,
    y: 33.8372,
    width: 1.42,
    height: 30.4535,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 503.68,
    y: 20.3024,
    width: 1.42,
    height: 43.9884,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 499.26,
    y: 47.3721,
    width: 1.42,
    height: 16.9186,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 494.84,
    y: 6.76746,
    width: 1.42,
    height: 57.5233,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 490.42,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 486,
    y: 16.9186,
    width: 1.42,
    height: 47.3721,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 675.818,
    width: 1.42,
    height: 64.2907,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 671.398,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 666.979,
    y: 16.9186,
    width: 1.42,
    height: 47.3721,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 662.559,
    width: 1.42,
    height: 64.2907,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 658.139,
    y: 13.5349,
    width: 1.42,
    height: 50.7558,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 653.719,
    y: 30.4535,
    width: 1.42,
    height: 33.8372,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 649.299,
    y: 6.76746,
    width: 1.42,
    height: 57.5233,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 644.879,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 640.459,
    y: 47.3721,
    width: 1.42,
    height: 16.9186,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 636.039,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 631.619,
    y: 16.9186,
    width: 1.42,
    height: 47.3721,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 627.199,
    y: 33.8372,
    width: 1.42,
    height: 30.4535,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 622.779,
    y: 10.1511,
    width: 1.42,
    height: 54.1395,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 618.359,
    y: 30.4535,
    width: 1.42,
    height: 33.8372,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 613.939,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 609.52,
    width: 1.42,
    height: 64.2907,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: 605.1,
    y: 33.8372,
    width: 1.42,
    height: 30.4535,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 600.68,
    y: 20.3024,
    width: 1.42,
    height: 43.9884,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 596.26,
    y: 47.3721,
    width: 1.42,
    height: 16.9186,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 591.84,
    y: 6.76746,
    width: 1.42,
    height: 57.5233,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 587.42,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    x: 583,
    y: 16.9186,
    width: 1.42,
    height: 47.3721,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 772.818,
    width: 1.42,
    height: 64.2907,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 768.398,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 763.979,
    y: 16.9186,
    width: 1.42,
    height: 47.3721,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 759.559,
    width: 1.42,
    height: 64.2907,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 755.139,
    y: 13.5349,
    width: 1.42,
    height: 50.7558,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    x: 750.719,
    y: 30.4535,
    width: 1.42,
    height: 33.8372,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 746.299,
    y: 6.76746,
    width: 1.42,
    height: 57.5233,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 741.879,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 737.459,
    y: 47.3721,
    width: 1.42,
    height: 16.9186,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 733.039,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    x: 728.619,
    y: 16.9186,
    width: 1.42,
    height: 47.3721,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 724.199,
    y: 33.8372,
    width: 1.42,
    height: 30.4535,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 719.779,
    y: 10.1511,
    width: 1.42,
    height: 54.1395,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    x: 715.359,
    y: 30.4535,
    width: 1.42,
    height: 33.8372,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    x: 710.939,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    x: 706.52,
    width: 1.42,
    height: 64.2907,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    x: 702.1,
    y: 33.8372,
    width: 1.42,
    height: 30.4535,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    x: 697.68,
    y: 20.3024,
    width: 1.42,
    height: 43.9884,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    x: 693.26,
    y: 47.3721,
    width: 1.42,
    height: 16.9186,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    x: 688.84,
    y: 6.76746,
    width: 1.42,
    height: 57.5233,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    x: 684.42,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 16.9186,
    width: 1.42,
    height: 47.3721,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    x: 869.818,
    width: 1.42,
    height: 64.2907,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 865.398,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    x: 860.979,
    y: 16.9186,
    width: 1.42,
    height: 47.3721,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    x: 856.559,
    width: 1.42,
    height: 64.2907,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    x: 852.139,
    y: 13.5349,
    width: 1.42,
    height: 50.7558,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    x: 847.719,
    y: 30.4535,
    width: 1.42,
    height: 33.8372,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    x: 843.299,
    y: 6.76746,
    width: 1.42,
    height: 57.5233,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    x: 838.879,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    x: 834.459,
    y: 47.3721,
    width: 1.42,
    height: 16.9186,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    x: 830.039,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    x: 825.619,
    y: 16.9186,
    width: 1.42,
    height: 47.3721,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    x: 821.199,
    y: 33.8372,
    width: 1.42,
    height: 30.4535,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    x: 816.779,
    y: 10.1511,
    width: 1.42,
    height: 54.1395,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    x: 812.359,
    y: 30.4535,
    width: 1.42,
    height: 33.8372,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    x: 807.939,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    x: 803.52,
    width: 1.42,
    height: 64.2907,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    x: 799.1,
    y: 33.8372,
    width: 1.42,
    height: 30.4535,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    x: 794.68,
    y: 20.3024,
    width: 1.42,
    height: 43.9884,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    x: 790.26,
    y: 47.3721,
    width: 1.42,
    height: 16.9186,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    x: 785.84,
    y: 6.76746,
    width: 1.42,
    height: 57.5233,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    x: 781.42,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    x: 777,
    y: 16.9186,
    width: 1.42,
    height: 47.3721,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    x: 966.818,
    width: 1.42,
    height: 64.2907,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    x: 962.398,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    x: 957.979,
    y: 16.9186,
    width: 1.42,
    height: 47.3721,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    x: 953.559,
    width: 1.42,
    height: 64.2907,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    x: 949.139,
    y: 13.5349,
    width: 1.42,
    height: 50.7558,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    x: 944.719,
    y: 30.4535,
    width: 1.42,
    height: 33.8372,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    x: 940.299,
    y: 6.76746,
    width: 1.42,
    height: 57.5233,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    x: 935.879,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    x: 931.459,
    y: 47.3721,
    width: 1.42,
    height: 16.9186,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    x: 927.039,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    x: 922.619,
    y: 16.9186,
    width: 1.42,
    height: 47.3721,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    x: 918.199,
    y: 33.8372,
    width: 1.42,
    height: 30.4535,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    x: 913.779,
    y: 10.1511,
    width: 1.42,
    height: 54.1395,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    x: 909.359,
    y: 30.4535,
    width: 1.42,
    height: 33.8372,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    x: 904.939,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    x: 900.52,
    width: 1.42,
    height: 64.2907,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    x: 896.1,
    y: 33.8372,
    width: 1.42,
    height: 30.4535,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    x: 891.68,
    y: 20.3024,
    width: 1.42,
    height: 43.9884,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    x: 887.26,
    y: 47.3721,
    width: 1.42,
    height: 16.9186,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    x: 882.84,
    y: 6.76746,
    width: 1.42,
    height: 57.5233,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    x: 878.42,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    x: 874,
    y: 16.9186,
    width: 1.42,
    height: 47.3721,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    x: 1024.82,
    width: 1.42,
    height: 64.2907,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    x: 1020.4,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    x: 1015.98,
    y: 16.9186,
    width: 1.42,
    height: 47.3721,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    x: 1011.56,
    width: 1.42,
    height: 64.2907,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    x: 1007.14,
    y: 13.5349,
    width: 1.42,
    height: 50.7558,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    x: 1002.72,
    y: 30.4535,
    width: 1.42,
    height: 33.8372,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    x: 998.299,
    y: 6.76746,
    width: 1.42,
    height: 57.5233,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    x: 993.879,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    x: 989.459,
    y: 47.3721,
    width: 1.42,
    height: 16.9186,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    x: 985.039,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    x: 980.619,
    y: 16.9186,
    width: 1.42,
    height: 47.3721,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    x: 976.199,
    y: 33.8372,
    width: 1.42,
    height: 30.4535,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    x: 971.779,
    y: 10.1511,
    width: 1.42,
    height: 54.1395,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    x: 1083.04,
    width: 1.42,
    height: 64.2907,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect235 || (_rect235 = /*#__PURE__*/React.createElement("rect", {
    x: 1091.42,
    width: 1.42,
    height: 64.2907,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect236 || (_rect236 = /*#__PURE__*/React.createElement("rect", {
    x: 1099.8,
    width: 1.42,
    height: 64.2907,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect237 || (_rect237 = /*#__PURE__*/React.createElement("rect", {
    x: 1078.62,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect238 || (_rect238 = /*#__PURE__*/React.createElement("rect", {
    x: 1087,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect239 || (_rect239 = /*#__PURE__*/React.createElement("rect", {
    x: 1095.38,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect240 || (_rect240 = /*#__PURE__*/React.createElement("rect", {
    x: 1074.2,
    y: 16.9186,
    width: 1.42,
    height: 47.3721,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect241 || (_rect241 = /*#__PURE__*/React.createElement("rect", {
    x: 1069.78,
    width: 1.42,
    height: 64.2907,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect242 || (_rect242 = /*#__PURE__*/React.createElement("rect", {
    x: 1065.36,
    y: 13.5349,
    width: 1.42,
    height: 50.7558,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect243 || (_rect243 = /*#__PURE__*/React.createElement("rect", {
    x: 1060.94,
    y: 30.4535,
    width: 1.42,
    height: 33.8372,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect244 || (_rect244 = /*#__PURE__*/React.createElement("rect", {
    x: 1056.52,
    y: 6.76746,
    width: 1.42,
    height: 57.5233,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect245 || (_rect245 = /*#__PURE__*/React.createElement("rect", {
    x: 1052.1,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect246 || (_rect246 = /*#__PURE__*/React.createElement("rect", {
    x: 1047.68,
    y: 47.3721,
    width: 1.42,
    height: 16.9186,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect247 || (_rect247 = /*#__PURE__*/React.createElement("rect", {
    x: 1043.26,
    y: 27.0698,
    width: 1.42,
    height: 37.2209,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect248 || (_rect248 = /*#__PURE__*/React.createElement("rect", {
    x: 1038.84,
    y: 16.9186,
    width: 1.42,
    height: 47.3721,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect249 || (_rect249 = /*#__PURE__*/React.createElement("rect", {
    x: 1034.42,
    y: 33.8372,
    width: 1.42,
    height: 30.4535,
    rx: 0.71,
    fill: "#4D0B0E"
  })), _rect250 || (_rect250 = /*#__PURE__*/React.createElement("rect", {
    x: 1030,
    y: 10.1511,
    width: 1.42,
    height: 54.1395,
    rx: 0.71,
    fill: "#4D0B0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.cb413da91299272332c87fac632bbff0.svg";
export { ForwardRef as ReactComponent };